export function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-5 lg:mb-6 pb-4 border-b border-[var(--border-line)]" data-testid={testId || "page-header"}>
      <div>
        <div className="label-mono mb-2">{subtitle || "Module"}</div>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">{title}</h1>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function StatCard({ label, value, accent = "cyan", icon: Icon, sub, testId }) {
  const colorClass = accent === "green" ? "text-[var(--primary-dark)]" : accent === "pink" ? "text-[var(--alert)]" : accent === "warn" ? "text-[#B45309]" : "text-[var(--primary)]";
  return (
    <div className="surface glow-border p-4 sm:p-5 relative overflow-hidden" data-testid={testId}>
      <div className="flex items-start justify-between gap-2">
        <div className="label-mono">{label}</div>
        {Icon ? <Icon size={16} className="text-[var(--text-muted)] shrink-0" /> : null}
      </div>
      <div className={`font-heading ${colorClass} text-2xl sm:text-3xl lg:text-[2rem] font-extrabold mt-2 sm:mt-3 tracking-tight break-words`}>{value}</div>
      {sub ? <div className="text-xs text-[var(--text-muted)] mt-1 sm:mt-2 font-data">{sub}</div> : null}
    </div>
  );
}

export function Surface({ children, className = "", title, action, testId }) {
  return (
    <div className={`surface glow-border overflow-hidden ${className}`} data-testid={testId}>
      {(title || action) && (
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 border-b border-[var(--border-line)] gap-2">
          {title ? <div className="font-heading font-semibold tracking-tight text-sm sm:text-base">{title}</div> : <div />}
          {action}
        </div>
      )}
      <div className="overflow-x-auto">{children}</div>
    </div>
  );
}

export function Empty({ message = "Aucune donnée" }) {
  return (
    <div className="text-center py-10 text-[var(--text-muted)] text-sm font-data tracking-wide">
      &mdash;&nbsp; {message} &nbsp;&mdash;
    </div>
  );
}
